import request from '@/utils/request'

export function getPolicy(data) {
  return request({
    url: '/app/support/images/getPolicy',
    method: 'post',
    data
  })
}



export function getPolicyNew(data) {
  return request({
    url: '/app/support/images/getPolicyNew?hz=' + data,
    method: 'get'

  })
}


// WEBPACK FOOTER //
// ./src/api/system/oss.js